import React, { useEffect, useState, useContext } from 'react'
import './App.css'
import Routes from './routes'
import { BrowserRouter as Router } from 'react-router-dom'
import { CookiesProvider } from 'react-cookie'
import { I18nextProvider } from 'react-i18next'
import AuthState from '@/product/context/auth/authState'
import CustomCommonState from './custom/context/common/commonState'
import ProductCommonState from '@/product/context/common/commonState'
import UserState from '@/product/context/user/userState'
import AlertState from '@/product/context/alert/alertState'
import ProductState from '@/product/context/product/productState'
import InvoiceState from '@/product/context/invoice/invoiceState'
import DepositState from '@/product/context/deposit/depositState'
import AuctionState from '@/product/context/auction/auctionState'
import CreditState from '@/product/context/credit/creditState'
import OfflineState from '@/product/context/offline/offlineState'
import CartState from '@/product/context/cart/cartState'
import BuyerState from '@/product/context/buyer/buyerState'
import AutopltState from '@/product/context/autopilot/autopltState'
import PayState from '@/product/context/payment/payState'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import ArtaShippingState from './product/context/shipping/arta/artaState'
import DynamicState from './product/context/dynamic/dynamicState'
import MomentUtils from '@date-io/moment'
import Alerts from '@/custom/common/alert'
import BuynowState from '@/product/context/buynow/buynowState'
import AppointmentState from '@/product/context/appointment/appointmentState'
import RosoomState from '@/product/context/payment/rosoom/rosoomState'
import StripeCardState from './product/context/stripe/card/cardState'
import StripeCustomerState from './product/context/stripe/customer/customerState'
import StripeBankState from './product/context/stripe/bank/bankState'
import SellerProductState from './product/context/seller/product/productState'
import SellerSettingState from './product/context/seller/setting/settingState'
import ShipengineState from './product/context/shipping/shipengine/shipengineState'
import SellerAuctionState from './product/context/seller/auction/auctionState'
import TemplateProductState from './product/context/seller/template/product/productState'
import TemplateAuctionState from './product/context/seller/template/auction/auctionState'
import UserStateseller from './product/context/seller/user/userState'
import SellerReportState from './product/context/seller/report/reportState'
import ShipstationState from './product/context/shipping/shipstation/shipstationState'
import CommentState from '@/product/context/comment/commentState'
import NotesState from '@/product/context/notes/notesState'
import MessageState from './product/context/message/messageState'
import i18n from '@/product/common/language-i18n'
import withRoot from './withRoot'
import { create } from 'jss'
import rtl from 'jss-rtl'
import { Helmet } from 'react-helmet'
import CouponState from './product/context/coupon/couponState'
import SEO from '@/utils/SEO'
import {
    MuiThemeProvider,
    StylesProvider,
    createTheme,
    jssPreset,
    useTheme,
} from '@material-ui/core/styles'
import CustomCommonContext from './custom/context/common/commonContext'
import OfferState from './product/context/offer/offerState'
import HeadAlert from './custom/components/molecules/HeadAlert'
import { setIPAddress } from './product/common/api'
import publicIp from 'public-ip'
import BidState from '@/product/context/reverse/bid/bidState'
import MembershipState from './product/context/membership/membershipState'
import { GoogleOAuthProvider } from '@react-oauth/google'
import ipLocation from 'iplocation'
import ReturnState from './product/context/return/returnState'
import SchedulePickupState from './product/context/schedulePickup/schedulePickupState'
import { SignProvider } from './custom/context/signContext'
import { customToastMessageColors } from './utils/common'
import LocationState from '@/custom/context/location/locationState'

global.site_url = process.env.REACT_APP_DOMAIN
global.images_url = global.site_url + '/uploads/product/'
global.ignoreStates = []
global.ignoreCountry = []
global.formatPhone = true
global.defaultCountry = 'US'
global.defaultState = 'OH'
global.noLoginRedirect = true
global.successBidMessage = {
    sealedSuccess: 'Offer Placed Successfully',
    bidSuccess: 'Offer Placed Successfully',
    prebidSuccess: 'Offer Placed Successfully',
}
global.bidErrorMessage = 'Please submit higher offer'
const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_V3_SITE_KEY

global.capcha_key = recaptchaSiteKey
global.captcha_key = recaptchaSiteKey
global.customToastMessageColors = customToastMessageColors || {}

const App = () => {
    const jss = create({ plugins: [...jssPreset().plugins, rtl()] })

    const [currLang, setCurrLang] = useState()
    const theme = useTheme()
    const ltrTheme = createTheme({ direction: 'ltr' })
    const rtlTheme = createTheme({ direction: 'rtl' })
    global.registerToken = true

    useEffect(() => {
        setCurrLang(localStorage.currLanguage == 'for_english' ? rtlTheme : ltrTheme)
    }, [localStorage.currLanguage])

    useEffect(() => {
        async function fetchData() {
            try {
                const ipaddress = await publicIp.v4()
                const ipLoc = await ipLocation(ipaddress || null)
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        async (position) => {
                            const latitude = position.coords.latitude
                            const longitude = position.coords.longitude
                            const response = await fetch(
                                `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`,
                            )
                            const data = await response.json()
                            console.log(data, 'data location selector')
                            const locationName =
                                data?.name ||
                                data?.address?.county + ' ' + data?.address?.state ||
                                data?.display_name ||
                                data?.address?.state ||
                                ''
                            localStorage.setItem(
                                'geoLocation',
                                JSON.stringify({
                                    latitude: position.coords.latitude,
                                    longitude: position.coords.longitude,
                                    locationName: locationName || '',
                                    city: data?.address?.city || '',
                                    state: data?.address?.state || '',
                                    zip: data?.address?.postcode || '',
                                    country: data?.address?.country || '',
                                    from: 'browser',
                                }),
                            )
                            window.dispatchEvent(new CustomEvent('geoLocationReady'))
                        },
                        (err) => {
                            if (err && ipLoc?.latitude && ipLoc?.longitude) {
                                console.log('i am location ip err ', err, ipLoc)
                                localStorage.setItem(
                                    'geoLocation',
                                    JSON.stringify({
                                        latitude: ipLoc.latitude,
                                        longitude: ipLoc.longitude,
                                        locationName: ipLoc?.city || ipLoc.region || '',
                                        city: ipLoc?.city || '',
                                        state: ipLoc?.region?.name || '',
                                        zip: ipLoc?.postalCode || '',
                                        country: ipLoc?.country?.name || '',
                                        from: 'ipaddress',
                                    }),
                                )
                                window.dispatchEvent(new CustomEvent('geoLocationReady'))
                            }
                        },
                    )
                } else if (ipLoc?.latitude && ipLoc?.longitude) {
                    localStorage.setItem(
                        'geoLocation',
                        JSON.stringify({
                            latitude: ipLoc.latitude,
                            longitude: ipLoc.longitude,
                            locationName: ipLoc?.city || ipLoc.region || '',
                            from: 'ipaddress',
                        }),
                    )
                    window.dispatchEvent(new CustomEvent('geoLocationReady'))
                }
                setIPAddress(ipaddress)
            } catch (error) {
                console.error('Error fetching user location data: ', error)
            }
        }
        fetchData()
    }, [])

    return (
        <>
            <SEO url={window.location.href} />
            <CookiesProvider>
                <StylesProvider jss={jss}>
                    <I18nextProvider i18n={i18n}>
                        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
                            <CustomCommonState>
                                {/* <StylesProvider jss={jss}>
                        <MuiThemeProvider
                            theme={createMuiTheme({
                                direction: currLang,
                            })}
                        > */}

                                <ProductCommonState>
                                    <AuthState>
                                        <SignProvider>
                                            <AlertState>
                                                <UserState>
                                                    <UserStateseller>
                                                        <CommentState>
                                                            <NotesState>
                                                                <StripeCardState>
                                                                    <StripeCustomerState>
                                                                        <StripeBankState>
                                                                            <ProductState>
                                                                                <AuctionState>
                                                                                    <BuynowState>
                                                                                        <CartState>
                                                                                            <AppointmentState>
                                                                                                <CreditState>
                                                                                                    <CouponState>
                                                                                                        <RosoomState>
                                                                                                            <PayState>
                                                                                                                <SellerReportState>
                                                                                                                    <SellerSettingState>
                                                                                                                        <OfflineState>
                                                                                                                            <OfferState>
                                                                                                                                <InvoiceState>
                                                                                                                                    <SchedulePickupState>
                                                                                                                                        <ReturnState>
                                                                                                                                            <DepositState>
                                                                                                                                                <BuyerState>
                                                                                                                                                    <AutopltState>
                                                                                                                                                        <ArtaShippingState>
                                                                                                                                                            <ShipengineState>
                                                                                                                                                                <SellerProductState>
                                                                                                                                                                    <SellerAuctionState>
                                                                                                                                                                        <TemplateProductState>
                                                                                                                                                                            <TemplateAuctionState>
                                                                                                                                                                                <ShipstationState>
                                                                                                                                                                                    <BidState>
                                                                                                                                                                                        <MessageState>
                                                                                                                                                                                            <DynamicState>
                                                                                                                                                                                                <MembershipState>
                                                                                                                                                                                                    <MuiPickersUtilsProvider
                                                                                                                                                                                                        utils={
                                                                                                                                                                                                            MomentUtils
                                                                                                                                                                                                        }
                                                                                                                                                                                                    >
                                                                                                                                                                                                        <div className="App">
                                                                                                                                                                                                            <Alerts />
                                                                                                                                                                                                            <HeadAlert />
                                                                                                                                                                                                            <Router>
                                                                                                                                                                                                                <LocationState>
                                                                                                                                                                                                                    <Routes />
                                                                                                                                                                                                                </LocationState>
                                                                                                                                                                                                            </Router>
                                                                                                                                                                                                        </div>
                                                                                                                                                                                                    </MuiPickersUtilsProvider>
                                                                                                                                                                                                </MembershipState>
                                                                                                                                                                                            </DynamicState>
                                                                                                                                                                                        </MessageState>
                                                                                                                                                                                    </BidState>
                                                                                                                                                                                </ShipstationState>
                                                                                                                                                                            </TemplateAuctionState>
                                                                                                                                                                        </TemplateProductState>
                                                                                                                                                                    </SellerAuctionState>
                                                                                                                                                                </SellerProductState>
                                                                                                                                                            </ShipengineState>
                                                                                                                                                        </ArtaShippingState>
                                                                                                                                                    </AutopltState>
                                                                                                                                                </BuyerState>
                                                                                                                                            </DepositState>
                                                                                                                                        </ReturnState>
                                                                                                                                    </SchedulePickupState>
                                                                                                                                </InvoiceState>
                                                                                                                            </OfferState>
                                                                                                                        </OfflineState>
                                                                                                                    </SellerSettingState>
                                                                                                                </SellerReportState>
                                                                                                            </PayState>
                                                                                                        </RosoomState>
                                                                                                    </CouponState>
                                                                                                </CreditState>
                                                                                            </AppointmentState>
                                                                                        </CartState>
                                                                                    </BuynowState>
                                                                                </AuctionState>
                                                                            </ProductState>
                                                                        </StripeBankState>
                                                                    </StripeCustomerState>
                                                                </StripeCardState>
                                                            </NotesState>
                                                        </CommentState>
                                                    </UserStateseller>
                                                </UserState>
                                            </AlertState>
                                        </SignProvider>
                                    </AuthState>
                                </ProductCommonState>
                                {/* </MuiThemeProvider>
                    </StylesProvider> */}
                            </CustomCommonState>
                        </GoogleOAuthProvider>
                    </I18nextProvider>
                </StylesProvider>
            </CookiesProvider>
        </>
    )
}

export default withRoot(App)
